import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_ROLE } from '../../data.const';
import {
  retrieveRolesAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteRoleEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_ROLE),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    // tap(p => console.log(`[epic ${DELETE_ROLE}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ roleLoader: true })),
        defer(() =>
          from(
            request({ path: `role`, method: httpMethods.DELETE, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_ROLE}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveRolesAction(listBody))),
            catchError(err => {
              console.error(`[epic ${DELETE_ROLE}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ roleLoader: false }))
      );
    })
  );

export default deleteRoleEpic;
